import React from 'react';
import PropTypes from 'prop-types';

import PageHeader from 'common/designer-modules/modules/page-header';
import { useSelector } from 'react-redux';
import { siteInfoSelector } from 'admin/state/modules/common/selectors';

const SiteDesignerRightSideLogo = ({
   globalSettings,
}) => {
   const siteInfo = useSelector(siteInfoSelector);
   return (
      <PageHeader
         globalSettings={ globalSettings }
         siteName={ siteInfo.site_long_name }
         isPreview
      />
   )
}

SiteDesignerRightSideLogo.propTypes = {
   globalSettings: PropTypes.object,
}

export default SiteDesignerRightSideLogo;
